import React, { Component } from 'react';

import { BLHeader, BigSectionDiv, BLDiv } from '../../AppStyles/GenericStyledComponents';

import Project from '../../../assets/images/ProjectBoard.jpeg'
import BLStyleGuide from '../../AppStyles/BLStyleGuide'
import './scroll.css'

class TopPicText extends Component {
  render() {
      return (  
          <BigSectionDiv
            desktopImage={`url(${Project})`} 
            background={`linear-gradient(rgba(255, 255, 255, .7), rgba(255, 255, 255, .7)), url(${Project})`}
            >
            <BLHeader
              fontWeight={'300'}
              fontSize={BLStyleGuide.font.size.mediumLarge}
              color={BLStyleGuide.color.title}
              fontFamily={BLStyleGuide.font.family.monoFur}
              smallTabletSize={BLStyleGuide.font.size.mediumSmall}
              mobileFontSize={BLStyleGuide.font.size.small}
              >
              Have an app idea?<br/>See room for improvement?<br/>Interested in joining our team?<br/>Let us know...
            </BLHeader>
          </BigSectionDiv>
    );
  }
}

export default TopPicText;



// WEBPACK FOOTER //
// ./src/interface/components/Contact Us/TopPicText.js